module.exports = __webpack_public_path__ + "static/icons/icon-snow-report--white-dc18c6f32dbefc5fa56d66fb09270d7c.svg";